import {
  ADMIN_PATH,
  CUSTOMERS_PATH,
  DATA_MANAGEMENT_PATH,
  hasRequiredPermission,
  PERMISSIONS,
  QUOTATION_TOOL_PATH
} from '@common/utils'
import { MolsonBox, MolsonLink } from '@components/reusable'
import { useNavigate, useParams } from 'react-router-dom'
import { useClearAttachmentCache } from '@/shared-queries/attachments'
import { useClearEquipmentCache } from '@/shared-queries/machines'
import { useAuthStore } from '@/stores/authStore'
import { useLeaveGuardStore } from '@/stores/leaveGuardStore'
import { usePermissionsStore } from '@/stores/permissionsStore'
import { isActiveRoute } from '@/utils/nav-functions'

const allRoutes = [
  {
    pageName: 'Quotes',
    path: QUOTATION_TOOL_PATH,
    permissionKey: PERMISSIONS.MY_QUOTES
  },
  {
    pageName: 'Data Management',
    path: DATA_MANAGEMENT_PATH,
    permissionKey: PERMISSIONS.DATA_MANAGEMENT
  },
  {
    pageName: 'Customers',
    path: CUSTOMERS_PATH,
    permissionKey: PERMISSIONS.CUSTOMERS
  },
  {
    pageName: 'Admin',
    path: ADMIN_PATH,
    permissionKey: PERMISSIONS.USERS
  }
]

export const Links = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()
  const { permissions } = usePermissionsStore()
  const { equipmentId, attachmentId } = useParams()

  const routes = isAuthenticated ? allRoutes : []

  const hasUnsavedChanges = useLeaveGuardStore(state => state.hasUnsavedChanges)

  const { mutateAsync: clearMachine } = useClearEquipmentCache()
  const { mutateAsync: clearAttachment } = useClearAttachmentCache()

  const onDiscard = async () => {
    if (equipmentId && !hasUnsavedChanges) {
      await clearMachine()
    }
    if (attachmentId && !hasUnsavedChanges) {
      await clearAttachment()
    }
  }

  const handleNavigation = (path: string) => {
    onDiscard()
    navigate(path)
  }

  return (
    <MolsonBox
      sx={{
        display: {
          md: 'flex',
          xs: 'none'
        },
        gap: '4px',
        alignItems: 'center !important'
      }}
    >
      {routes.map(({ pageName, path, permissionKey }) => {
        if (!hasRequiredPermission(permissionKey, permissions)) {
          return null
        }

        return (
          //@ts-ignore
          <MolsonLink
            component={'div'}
            sx={{ '&:hover': { cursor: 'pointer' }, minWidth: 'fit-content' }}
            isActive={isActiveRoute(location.pathname, path)}
            key={permissionKey}
            onClick={() => handleNavigation(path)}
          >
            {pageName}
          </MolsonLink>
        )
      })}
    </MolsonBox>
  )
}
